import { adminHttpClient } from '../commons/adminHttpClient'

type SetPasswordForUserRequest = {
  userId: string
  newPassword: string
}

const setPasswordForUser = (request: SetPasswordForUserRequest): Promise<any> => {
  return adminHttpClient.put('/Account/SetPasswordForUser', request)
}

export default setPasswordForUser
